/**
 * Lightbox Module
 * GLightbox initialization
 */

import GLightbox from "glightbox";

export function initLightbox() {
  const lightboxElements = document.querySelectorAll(".glightbox");

  if (lightboxElements.length > 0) {
    const lightbox = GLightbox({
      selector: ".glightbox",
      touchNavigation: true,
      loop: true,
      width: "90vw",
      height: "90vh",
      videosWidth: "70vw",
      beforeSlideChange: (slide, data) => {
        console.log("Slide changed");
      },
    });

    console.log("GLightbox initialized with", lightboxElements.length, "elements");
  } else {
    console.log("No glightbox elements found");
  }
}
